<app-painel-lateral [tituloPainel]="'Médicos Ativos por Data'" [descricaoPainel]="'Total de médicos ativos em uma data de corte, com a relação detalhada.'" [iconePainel]="'pi pi-users'" [filtrosTemplate]="filtros" [conteudoTemplate]="conteudo">
</app-painel-lateral>

<ng-template #filtros>
    <app-mapa-uf-card [uf]="ufSelecionada" (ufChange)="onUfSelecionadaChange($event)"></app-mapa-uf-card>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">UF do estado</span>
        <app-estado-select [uf]="ufSelecionada ?? 'BR'" [ufsPermitidas]="ufsPermitidas" (ufChange)="onUfSelecionadaChange($event)"></app-estado-select>
    </label>
    <label class="mapa-filtro">
        <span class="mapa-filtro-label">Data de corte</span>
        <p-datepicker [(ngModel)]="dataCorte" dateFormat="dd/mm/yy" [showIcon]="true" [appendTo]="'body'" [maxDate]="hoje" [showButtonBar]="true" [invalid]="!dataCorte" ariaLabel="Data de corte"></p-datepicker>
        @if (!dataCorte) {
            <small class="mapa-filtro-erro">Informe a data de corte para consultar.</small>
        }
    </label>
    <p-button label="Aplicar" icon="pi pi-search" [disabled]="!dataCorte" (onClick)="aplicar()"></p-button>
</ng-template>

<ng-template #conteudo>
    <app-card-content [border]="false" [title]="'Médicos ativos'" [subtitle]="'Posição em ' + (dataFormatada | dataExtenso)" icon="pi pi-users">
        <div card-header class="flex items-center gap-2">
            <p-button
                icon="pi pi-table"
                styleClass="botao-topo-acao"
                [text]="true"
                [rounded]="true"
                [disabled]="carregandoTotal"
                title="Visualizar dados estatísticos"
                ariaLabel="Visualizar dados estatísticos"
                (onClick)="mostrarDetalhes()"
            ></p-button>
        </div>
        <div class="ativos-total">
            @if (carregandoTotal) {
                <p-skeleton width="120px" height="34px" />
            } @else {
                <span class="ativos-total-valor">{{ total ?? 0 | number }}</span>
                <span class="ativos-total-label">ativos{{ ufConsulta ? ' — ' + ufConsulta : '' }}</span>
            }
        </div>
    </app-card-content>

    @if (mostrarLista) {
        <app-custom-table
            [data]="linhas"
            [metadata]="tabelaMetadata"
            [loading]="carregandoLista"
            [first]="first"
            [rows]="rows"
            [totalRecords]="totalRecords"
            [rowsPerPageOptions]="[100, 200, 300]"
            [showActions]="false"
            [showExpandButton]="false"
            [showExport]="true"
            [exportFileName]="'medicos-ativos-' + dataFormatada"
            (onPageChange)="onPageChange($event)"
        ></app-custom-table>
    }
</ng-template>
